import { ChevronDown, RotateCw, TriangleAlert } from "lucide-react";
import { useState } from "react";
import { isApiError, plainMessage } from "@/api/errors";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { CopyButton } from "./CopyButton";

export function ErrorState({ error, onRetry, title = "Couldn't load this" }: { error: unknown; onRetry?: () => void; title?: string }) {
  const [open, setOpen] = useState(false);
  const api = isApiError(error) ? error : null;
  return (
    <div role="alert" className="flex flex-col items-center gap-3 px-4 py-10 text-center">
      <TriangleAlert aria-hidden className="size-8 text-tone-orange-fg" />
      <h2 className="text-md font-semibold">{title}</h2>
      <p className="max-w-md text-muted-foreground">{plainMessage(error)}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          <RotateCw aria-hidden /> Retry
        </Button>
      )}
      {api && (
        <Collapsible open={open} onOpenChange={setOpen} className="w-full max-w-md">
          <CollapsibleTrigger asChild>
            <Button variant="link" size="sm">
              Technical details <ChevronDown aria-hidden className={open ? "rotate-180" : ""} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent>
            <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 rounded-md border p-3 text-left text-xs">
              <dt className="text-muted-foreground">Code</dt>
              <dd className="font-mono">{api.code}</dd>
              <dt className="text-muted-foreground">HTTP status</dt>
              <dd className="font-mono">{api.status || "—"}</dd>
              <dt className="text-muted-foreground">Request ID</dt>
              <dd className="flex items-center gap-1 font-mono">
                {api.requestId || "—"}
                {api.requestId && <CopyButton value={api.requestId} label="Copy request ID" />}
              </dd>
            </dl>
          </CollapsibleContent>
        </Collapsible>
      )}
    </div>
  );
}
